import { combineTokens } from '@utils/css';

const iconCrossfadeDurationMs = 100;
const tokens = combineTokens("--bullet", {
  scale: 1,
  origin: "center"
});
const wrapper = "_35sw1vz5rgv";
const bullet = "_35sb1sde7pm";
const iconWrapper = "_35si1c93bei";
const bulletIcon = "_35sb2jb4xf";

export { bullet, bulletIcon, iconCrossfadeDurationMs, iconWrapper, tokens, wrapper };
import "./atom.bullet.style.linaria.module.css";
//# sourceMappingURL=atom.bullet.style.js.map
